import { render, staticRenderFns } from "./courseInternational.vue?vue&type=template&id=fcec32bc&scoped=true"
import script from "./courseInternational.vue?vue&type=script&lang=js"
export * from "./courseInternational.vue?vue&type=script&lang=js"
import style0 from "./courseInternational.vue?vue&type=style&index=0&id=fcec32bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcec32bc",
  null
  
)

export default component.exports